var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M12.688 0l-1.532 1.54-.704-.703a1.833 1.833 0 0 0-2.587 0L6.401 2.311l-.4-.4a.304.304 0 0 0-.285-.085.304.304 0 0 0-.152.523l1.455 1.455-1.864 1.874.428.428 1.874-1.864 2.301 2.301-1.864 1.874.428.428 1.874-1.864 1.455 1.455A.31.31 0 1 0 12.088 8l-.4-.4 1.475-1.464a1.82 1.82 0 0 0 0-2.578v-.01l-.704-.703L14 1.313 12.687 0zM2.101 5.469a.304.304 0 0 0-.038.01.304.304 0 0 0-.152.522l.4.4L.836 7.865a1.832 1.832 0 0 0 0 2.587l.704.695L0 12.687 1.313 14l1.54-1.54.695.703a1.833 1.833 0 0 0 2.587 0l1.464-1.474.4.4a.31.31 0 1 0 .437-.438L2.35 5.564a.304.304 0 0 0-.247-.095z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.30d69c04dbcb43d78ca68023e2ef79db.svg";
export { ForwardRef as ReactComponent };